import React, { useCallback, type FC } from 'react'
import {
  Panel,
  Flex,
  Title,
  TITLE_VARIANT_L,
  Button,
  BUTTON_VARIANT_SECONDARY,
  Link,
  LINK_VARIANT_EXTRALIGHT,
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import ConditionsBlock from './ConditionsBlock'
import { useAtom } from 'jotai'
import { filterFormImmerAtom } from '../state/state'
import { getEmptyBlock } from '../utils/conditionUtils'

const ConditionsPanel: FC = () => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)

  const addBlock = useCallback((): void => {
    setFilter((draft) => {
      draft.Blocks.push(getEmptyBlock(draft.Blocks.length))
    })
  }, [setFilter])

  const removeAllBlocks = useCallback((): void => {
    setFilter((draft) => {
      draft.Blocks = [getEmptyBlock()]
    })
  }, [setFilter])

  return (
    <Panel>
      <Flex
        flexDirection='row'
        gap='24px'
        alignItems='center'
        justifyContent='space-between'
      >
        <Title variant={TITLE_VARIANT_L}>
          {intl.formatMessage({
            id: 'Load.CombinedFilterForm.ConditionsPanelTitle',
          })}
        </Title>
        <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={removeAllBlocks}>
          {intl.formatMessage({
            id: 'Load.CombinedFilterForm.DeleteAllConditions',
          })}
        </Link>
      </Flex>
      {filter.Blocks.map((_, i) => (
        <ConditionsBlock key={`block_${i}`} blockIndex={i} />
      ))}
      <Flex justifyContent='start'>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test='filterForm-AddBlock'
          onClick={addBlock}
        >
          {intl.formatMessage({
            id: 'Load.CombinedFilterForm.AddConditionGroup',
          })}
        </Button>
      </Flex>
    </Panel>
  )
}

export default ConditionsPanel
